import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _210b37a4 = () => interopDefault(import('../pages/the-project/index.vue' /* webpackChunkName: "pages/the-project/index" */))
const _5ec1f259 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _87fb601a = () => interopDefault(import('../pages/archive/index.vue' /* webpackChunkName: "pages/archive/index" */))
const _7855aa00 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3fe0d00a = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _5ef1287a = () => interopDefault(import('../pages/career/index.vue' /* webpackChunkName: "pages/career/index" */))
const _628f0e6a = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _6df776e6 = () => interopDefault(import('../pages/public-information/index.vue' /* webpackChunkName: "pages/public-information/index" */))
const _048eda84 = () => interopDefault(import('../pages/visitor-information/index.vue' /* webpackChunkName: "pages/visitor-information/index" */))
const _1660dc50 = () => interopDefault(import('../pages/complaint-report.vue' /* webpackChunkName: "pages/complaint-report" */))
const _7deca908 = () => interopDefault(import('../pages/customer-service.vue' /* webpackChunkName: "pages/customer-service" */))
const _7dc12c4e = () => interopDefault(import('../pages/magazine/index.vue' /* webpackChunkName: "pages/magazine/index" */))
const _562db048 = () => interopDefault(import('../pages/mental-liget-event-subscription-confirmation.vue' /* webpackChunkName: "pages/mental-liget-event-subscription-confirmation" */))
const _03e1d898 = () => interopDefault(import('../pages/press/index.vue' /* webpackChunkName: "pages/press/index" */))
const _290bd193 = () => interopDefault(import('../pages/newsletter-subscription-confirmation.vue' /* webpackChunkName: "pages/newsletter-subscription-confirmation" */))
const _a6f20e2e = () => interopDefault(import('../pages/documents/index.vue' /* webpackChunkName: "pages/documents/index" */))
const _5f68ffec = () => interopDefault(import('../pages/map.vue' /* webpackChunkName: "pages/map" */))
const _0abc3049 = () => interopDefault(import('../pages/business-partners/index.vue' /* webpackChunkName: "pages/business-partners/index" */))
const _c6a65246 = () => interopDefault(import('../pages/programs-in-varosliget/index.vue' /* webpackChunkName: "pages/programs-in-varosliget/index" */))
const _4d41d3cc = () => interopDefault(import('../pages/the-project/our-first-10-years.vue' /* webpackChunkName: "pages/the-project/our-first-10-years" */))
const _bee5f792 = () => interopDefault(import('../pages/press/media-library/index.vue' /* webpackChunkName: "pages/press/media-library/index" */))
const _1cd75468 = () => interopDefault(import('../pages/the-project/swiper.vue' /* webpackChunkName: "pages/the-project/swiper" */))
const _2517ac5a = () => interopDefault(import('../pages/top-locations/balloon-fly.vue' /* webpackChunkName: "pages/top-locations/balloon-fly" */))
const _c584b7a0 = () => interopDefault(import('../pages/top-locations/bird-friendly-learning-trail.vue' /* webpackChunkName: "pages/top-locations/bird-friendly-learning-trail" */))
const _c18a5c8e = () => interopDefault(import('../pages/top-locations/house-of-hungarian-music.vue' /* webpackChunkName: "pages/top-locations/house-of-hungarian-music" */))
const _5b764050 = () => interopDefault(import('../pages/top-locations/house-of-the-hungarian-millennium.vue' /* webpackChunkName: "pages/top-locations/house-of-the-hungarian-millennium" */))
const _7ab2139d = () => interopDefault(import('../pages/top-locations/mocsenyi-mihaly-botanical-garden.vue' /* webpackChunkName: "pages/top-locations/mocsenyi-mihaly-botanical-garden" */))
const _1b92b722 = () => interopDefault(import('../pages/top-locations/museum-of-ethnography.vue' /* webpackChunkName: "pages/top-locations/museum-of-ethnography" */))
const _86ee1be6 = () => interopDefault(import('../pages/top-locations/museum-of-fine-arts.vue' /* webpackChunkName: "pages/top-locations/museum-of-fine-arts" */))
const _78f16b80 = () => interopDefault(import('../pages/top-locations/city-park-visitor-center.vue' /* webpackChunkName: "pages/top-locations/city-park-visitor-center" */))
const _b39be906 = () => interopDefault(import('../pages/top-locations/kresz-park.vue' /* webpackChunkName: "pages/top-locations/kresz-park" */))
const _b641c486 = () => interopDefault(import('../pages/top-locations/playground-of-varosliget.vue' /* webpackChunkName: "pages/top-locations/playground-of-varosliget" */))
const _7d0581f6 = () => interopDefault(import('../pages/top-locations/varosliget-promenade.vue' /* webpackChunkName: "pages/top-locations/varosliget-promenade" */))
const _c31adc20 = () => interopDefault(import('../pages/magazine/preview/_article_preview.vue' /* webpackChunkName: "pages/magazine/preview/_article_preview" */))
const _42a02fbf = () => interopDefault(import('../pages/press/media-library/_gallerycategory/index.vue' /* webpackChunkName: "pages/press/media-library/_gallerycategory/index" */))
const _3685cafa = () => interopDefault(import('../pages/programs-in-varosliget/preview/_program_preview.vue' /* webpackChunkName: "pages/programs-in-varosliget/preview/_program_preview" */))
const _cdc7f494 = () => interopDefault(import('../pages/press/media-library/_gallerycategory/_gallery.vue' /* webpackChunkName: "pages/press/media-library/_gallerycategory/_gallery" */))
const _680326b4 = () => interopDefault(import('../pages/archive/_article.vue' /* webpackChunkName: "pages/archive/_article" */))
const _13bbc830 = () => interopDefault(import('../pages/business-partners/_partnerInfo.vue' /* webpackChunkName: "pages/business-partners/_partnerInfo" */))
const _bc2c240e = () => interopDefault(import('../pages/career/_position.vue' /* webpackChunkName: "pages/career/_position" */))
const _692e10c4 = () => interopDefault(import('../pages/public-information/_data.vue' /* webpackChunkName: "pages/public-information/_data" */))
const _3cf17e00 = () => interopDefault(import('../pages/magazine/_article.vue' /* webpackChunkName: "pages/magazine/_article" */))
const _193e2054 = () => interopDefault(import('../pages/press/_release.vue' /* webpackChunkName: "pages/press/_release" */))
const _1f9fe84e = () => interopDefault(import('../pages/program-series/_programSeries.vue' /* webpackChunkName: "pages/program-series/_programSeries" */))
const _7bdf600a = () => interopDefault(import('../pages/programs-in-varosliget/_program.vue' /* webpackChunkName: "pages/programs-in-varosliget/_program" */))
const _342341a4 = () => interopDefault(import('../pages/the-project/_project.vue' /* webpackChunkName: "pages/the-project/_project" */))
const _1f6437e9 = () => interopDefault(import('../pages/visitor-information/_visitorInformation.vue' /* webpackChunkName: "pages/visitor-information/_visitorInformation" */))
const _7bc2ec90 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-projekt",
    component: _210b37a4,
    name: "the-project___hu"
  }, {
    path: "/adatvedelem",
    component: _5ec1f259,
    name: "privacy-policy___hu"
  }, {
    path: "/archivum",
    component: _87fb601a,
    name: "archive___hu"
  }, {
    path: "/en",
    component: _7855aa00,
    name: "index___en"
  }, {
    path: "/hirlevel-feliratkozas",
    component: _3fe0d00a,
    name: "newsletter___hu"
  }, {
    path: "/karrier",
    component: _5ef1287a,
    name: "career___hu"
  }, {
    path: "/kereses",
    component: _628f0e6a,
    name: "search___hu"
  }, {
    path: "/kozerdeku-adatok",
    component: _6df776e6,
    name: "public-information___hu"
  }, {
    path: "/latogatas",
    component: _048eda84,
    name: "visitor-information___hu"
  }, {
    path: "/liget-budapest-panaszkezeles",
    component: _1660dc50,
    name: "complaint-report___hu"
  }, {
    path: "/liget-budapest-ugyfelszolgalat",
    component: _7deca908,
    name: "customer-service___hu"
  }, {
    path: "/magazin",
    component: _7dc12c4e,
    name: "magazine___hu"
  }, {
    path: "/mental-liget-sikeres-feliratkozas",
    component: _562db048,
    name: "mental-liget-event-subscription-confirmation___hu"
  }, {
    path: "/sajto",
    component: _03e1d898,
    name: "press___hu"
  }, {
    path: "/sikeres-feliratkozas",
    component: _290bd193,
    name: "newsletter-subscription-confirmation___hu"
  }, {
    path: "/szakmai-anyagok",
    component: _a6f20e2e,
    name: "documents___hu"
  }, {
    path: "/terkep",
    component: _5f68ffec,
    name: "map___hu"
  }, {
    path: "/uzleti-partnereinknek",
    component: _0abc3049,
    name: "business-partners___hu"
  }, {
    path: "/varosligeti-programok",
    component: _c6a65246,
    name: "programs-in-varosliget___hu"
  }, {
    path: "/en/archive",
    component: _87fb601a,
    name: "archive___en"
  }, {
    path: "/en/business-partners",
    component: _0abc3049,
    name: "business-partners___en"
  }, {
    path: "/en/career",
    component: _5ef1287a,
    name: "career___en"
  }, {
    path: "/en/hirlevel-feliratkozas",
    component: _3fe0d00a,
    name: "newsletter___en"
  }, {
    path: "/en/kozerdeku-adatok",
    component: _6df776e6,
    name: "public-information___en"
  }, {
    path: "/en/liget-budapest-complaint-report",
    component: _1660dc50,
    name: "complaint-report___en"
  }, {
    path: "/en/liget-budapest-customer-service",
    component: _7deca908,
    name: "customer-service___en"
  }, {
    path: "/en/magazine",
    component: _7dc12c4e,
    name: "magazine___en"
  }, {
    path: "/en/map",
    component: _5f68ffec,
    name: "map___en"
  }, {
    path: "/en/mental-liget-subscription-successful",
    component: _562db048,
    name: "mental-liget-event-subscription-confirmation___en"
  }, {
    path: "/en/press",
    component: _03e1d898,
    name: "press___en"
  }, {
    path: "/en/privacy-policy",
    component: _5ec1f259,
    name: "privacy-policy___en"
  }, {
    path: "/en/programs-in-varosliget",
    component: _c6a65246,
    name: "programs-in-varosliget___en"
  }, {
    path: "/en/search",
    component: _628f0e6a,
    name: "search___en"
  }, {
    path: "/en/subscription-successful",
    component: _290bd193,
    name: "newsletter-subscription-confirmation___en"
  }, {
    path: "/en/szakmai-anyagok",
    component: _a6f20e2e,
    name: "documents___en"
  }, {
    path: "/en/the-project",
    component: _210b37a4,
    name: "the-project___en"
  }, {
    path: "/en/visitor-information",
    component: _048eda84,
    name: "visitor-information___en"
  }, {
    path: "/projekt/a-liget-projekt-elso-10-eve",
    component: _4d41d3cc,
    name: "the-project-our-first-10-years___hu"
  }, {
    path: "/sajto/mediatar",
    component: _bee5f792,
    name: "press-media-library___hu"
  }, {
    path: "/the-project/swiper",
    component: _1cd75468,
    name: "the-project-swiper___hu"
  }, {
    path: "/top-helyek/ballon-kilato",
    component: _2517ac5a,
    name: "top-locations-balloon-fly___hu"
  }, {
    path: "/top-helyek/madarbarat-tanosveny",
    component: _c584b7a0,
    name: "top-locations-bird-friendly-learning-trail___hu"
  }, {
    path: "/top-helyek/magyar-zene-haza",
    component: _c18a5c8e,
    name: "top-locations-house-of-hungarian-music___hu"
  }, {
    path: "/top-helyek/millennium-haza-neo-kortars-muveszeti-ter",
    component: _5b764050,
    name: "top-locations-house-of-the-hungarian-millennium___hu"
  }, {
    path: "/top-helyek/mocsenyi-mihaly-botanikus-kert",
    component: _7ab2139d,
    name: "top-locations-mocsenyi-mihaly-botanical-garden___hu"
  }, {
    path: "/top-helyek/neprajzi-muzeum",
    component: _1b92b722,
    name: "top-locations-museum-of-ethnography___hu"
  }, {
    path: "/top-helyek/szepmuveszeti-muzeum",
    component: _86ee1be6,
    name: "top-locations-museum-of-fine-arts___hu"
  }, {
    path: "/top-helyek/varosliget-latogatokozpont",
    component: _78f16b80,
    name: "top-locations-city-park-visitor-center___hu"
  }, {
    path: "/top-helyek/varosligeti-kresz-park",
    component: _b39be906,
    name: "top-locations-kresz-park___hu"
  }, {
    path: "/top-helyek/varosligeti-nagyjatszoter",
    component: _b641c486,
    name: "top-locations-playground-of-varosliget___hu"
  }, {
    path: "/top-helyek/varosligeti-promenad",
    component: _7d0581f6,
    name: "top-locations-varosliget-promenade___hu"
  }, {
    path: "/en/press/media",
    component: _bee5f792,
    name: "press-media-library___en"
  }, {
    path: "/en/the-project/our-first-10-years",
    component: _4d41d3cc,
    name: "the-project-our-first-10-years___en"
  }, {
    path: "/en/the-project/swiper",
    component: _1cd75468,
    name: "the-project-swiper___en"
  }, {
    path: "/en/top-locations/balloon-fly",
    component: _2517ac5a,
    name: "top-locations-balloon-fly___en"
  }, {
    path: "/en/top-locations/bird-friendly-learning-trail",
    component: _c584b7a0,
    name: "top-locations-bird-friendly-learning-trail___en"
  }, {
    path: "/en/top-locations/city-park-visitor-center",
    component: _78f16b80,
    name: "top-locations-city-park-visitor-center___en"
  }, {
    path: "/en/top-locations/house-of-hungarian-music",
    component: _c18a5c8e,
    name: "top-locations-house-of-hungarian-music___en"
  }, {
    path: "/en/top-locations/house-of-the-hungarian-millennium",
    component: _5b764050,
    name: "top-locations-house-of-the-hungarian-millennium___en"
  }, {
    path: "/en/top-locations/kresz-park",
    component: _b39be906,
    name: "top-locations-kresz-park___en"
  }, {
    path: "/en/top-locations/mocsenyi-mihaly-botanical-garden",
    component: _7ab2139d,
    name: "top-locations-mocsenyi-mihaly-botanical-garden___en"
  }, {
    path: "/en/top-locations/museum-of-ethnography",
    component: _1b92b722,
    name: "top-locations-museum-of-ethnography___en"
  }, {
    path: "/en/top-locations/museum-of-fine-arts",
    component: _86ee1be6,
    name: "top-locations-museum-of-fine-arts___en"
  }, {
    path: "/en/top-locations/playground-of-varosliget",
    component: _b641c486,
    name: "top-locations-playground-of-varosliget___en"
  }, {
    path: "/en/top-locations/varosliget-promenade",
    component: _7d0581f6,
    name: "top-locations-varosliget-promenade___en"
  }, {
    path: "/en/magazine/preview/:article_preview",
    component: _c31adc20,
    name: "magazine-preview-article_preview___en"
  }, {
    path: "/en/press/media/:gallerycategory",
    component: _42a02fbf,
    name: "press-media-library-gallerycategory___en"
  }, {
    path: "/en/programs-in-varosliget/preview/:program_preview",
    component: _3685cafa,
    name: "programs-in-varosliget-preview-program_preview___en"
  }, {
    path: "/en/press/media/:gallerycategory/:gallery",
    component: _cdc7f494,
    name: "press-media-library-gallerycategory-gallery___en"
  }, {
    path: "/en/archive/:article",
    component: _680326b4,
    name: "archive-article___en"
  }, {
    path: "/en/business-partners/:partnerInfo",
    component: _13bbc830,
    name: "business-partners-partnerInfo___en"
  }, {
    path: "/en/career/:position",
    component: _bc2c240e,
    name: "career-position___en"
  }, {
    path: "/en/kozerdeku-adatok/:data",
    component: _692e10c4,
    name: "public-information-data___en"
  }, {
    path: "/en/magazine/:article",
    component: _3cf17e00,
    name: "magazine-article___en"
  }, {
    path: "/en/press/:release",
    component: _193e2054,
    name: "press-release___en"
  }, {
    path: "/en/program-series/:programSeries",
    component: _1f9fe84e,
    name: "program-series-programSeries___en"
  }, {
    path: "/en/programs-in-varosliget/:program",
    component: _7bdf600a,
    name: "programs-in-varosliget-program___en"
  }, {
    path: "/en/the-project/:project",
    component: _342341a4,
    name: "the-project-project___en"
  }, {
    path: "/en/visitor-information/:visitorInformation",
    component: _1f6437e9,
    name: "visitor-information-visitorInformation___en"
  }, {
    path: "/magazin/preview/:article_preview",
    component: _c31adc20,
    name: "magazine-preview-article_preview___hu"
  }, {
    path: "/sajto/mediatar/:gallerycategory",
    component: _42a02fbf,
    name: "press-media-library-gallerycategory___hu"
  }, {
    path: "/varosligeti-programok/preview/:program_preview",
    component: _3685cafa,
    name: "programs-in-varosliget-preview-program_preview___hu"
  }, {
    path: "/sajto/mediatar/:gallerycategory/:gallery",
    component: _cdc7f494,
    name: "press-media-library-gallerycategory-gallery___hu"
  }, {
    path: "/archivum/:article",
    component: _680326b4,
    name: "archive-article___hu"
  }, {
    path: "/en/:slug",
    component: _7bc2ec90,
    name: "slug___en"
  }, {
    path: "/karrier/:position",
    component: _bc2c240e,
    name: "career-position___hu"
  }, {
    path: "/kozerdeku-adatok/:data",
    component: _692e10c4,
    name: "public-information-data___hu"
  }, {
    path: "/latogatas/:visitorInformation",
    component: _1f6437e9,
    name: "visitor-information-visitorInformation___hu"
  }, {
    path: "/magazin/:article",
    component: _3cf17e00,
    name: "magazine-article___hu"
  }, {
    path: "/programsorozatok/:programSeries",
    component: _1f9fe84e,
    name: "program-series-programSeries___hu"
  }, {
    path: "/projekt/:project",
    component: _342341a4,
    name: "the-project-project___hu"
  }, {
    path: "/sajto/:release",
    component: _193e2054,
    name: "press-release___hu"
  }, {
    path: "/uzleti-partnereinknek/:partnerInfo",
    component: _13bbc830,
    name: "business-partners-partnerInfo___hu"
  }, {
    path: "/varosligeti-programok/:program",
    component: _7bdf600a,
    name: "programs-in-varosliget-program___hu"
  }, {
    path: "/",
    component: _7855aa00,
    name: "index___hu"
  }, {
    path: "/:slug",
    component: _7bc2ec90,
    name: "slug___hu"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
